<template>
  <div class="page-landing">

    <div v-if="loading === false" class="container slick-wrapper" data-aos="fade-in" data-aos-once="true">
      <slick ref="slick" :options="slickOptions">
        <div v-for="item in items" v-bind:key="item.title" :caption="item.title" :href="item.image.path" :src="item.image.path"><img v-if="isDesktop" :src="item.image.path" /><img v-else :src="item.image_mobile.path" /></div>
        <!-- </lightbox> -->
      </slick>
    </div>

    <section class="arrow-down">
      <a @click="$scrollTo('#gallery-container')"><span></span></a>
    </section>

    <masonry-instagram id="section-collections" @onItemsEnded="itemsEnded = true;"></masonry-instagram>

    <contact-section v-if="itemsEnded" data-aos="slide-up" data-aos-once="true" data-aos-duration="1000"></contact-section>

    <vm-back-top :bottom="45" :right="25" :duration="1000" :timing="'ease'">
      <div class="top"><span></span></div>
    </vm-back-top>
  </div>
</template>

<script>
  // import EventBus from '@/controllers/EventBus'
  import auth from '@/apis/Auth'
  import * as moment from 'moment'
  import MasonryInstagram from '@/components/MasonryInstagram.vue'
  import ContactSection from '@/components/ContactSection.vue'

  // import img01 from '@/assets/lasting_impressions_banner_1.jpg'
  // import img02 from '@/assets/lasting_impressions_banner_2.jpg'
  // import img01m from '@/assets/lasting_impressions_banner_1_m.jpg'
  // import img02m from '@/assets/lasting_impressions_banner_2_m.jpg'
  import Slick from 'vue-slick'
  import Lightbox from 'vue-lightbox'

  export default {
    name: 'landing',
    components: {
      Slick,
      Lightbox,
      MasonryInstagram,
      ContactSection
    },
    data () {
      return {
        isDesktop: true,
        slickOptions: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
          responsive: [
            {
              breakpoint: 1008,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            }, {
              // 768 = tablet (not break yet)
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }, {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            }
          ]
        },
        // items: [
        //   {
        //     title: 'Showcase 01',
        //     image: {
        //       path: img01
        //     },
        //     image_mobile: {
        //       path: img01m
        //     },
        //     desc: '',
        //     other: ''
        //   },
        //   {
        //     title: 'Showcase 02',
        //     image: {
        //       path: img02
        //     },
        //     image_mobile: {
        //       path: img02m
        //     },
        //     desc: '',
        //     other: ''
        //   }
        // ],
        items: [],
        itemsEnded: false,
        error: undefined,
        loading: true
      }
    },
    computed: {
    },
    watch: {
    },
    created () {
      console.log('created Landing.vue')
    },
    mounted () {
      console.log('mounted Landing.vue')
      // window.GA('send', 'pageview')

      if (this.$route.query && this.$route.query.anchor) {
        console.log('automatic scroll to...: ' + this.$route.query.anchor)
        setTimeout(function () {
          this.$scrollTo('#' + this.$route.query.anchor)
        }.bind(this), 1000)
      }

      // on event resize
      this.isDesktop = (window.innerWidth >= 768)
      window.addEventListener('resize', function (event) {
        // console.log('on viewport change')
        this.isDesktop = (event.target.innerWidth >= 768)
      }.bind(this))

      this.refresh()
    },
    methods: {
      onScrollTo: function (name) {
        this.$scrollTo('#' + name)
      }.bind(this),

      next () {
        if (this.$refs.slick) {
          this.$refs.slick.next()
        }
      },
      prev () {
        if (this.$refs.slick) {
          this.$refs.slick.prev()
        }
      },
      reInit () {
        if (this.$refs.slick) {
          this.$refs.slick.reSlick()
        }
      },
      getItems: function (onComplete) {
        this.loading = true
        auth.carousel()
        .then(data => {
          onComplete(data)
          this.$nextTick(function () {
            this.reInit()
          })
          this.reInit()
          this.loading = false
        })
        .catch(error => {
          this.items = []
          this.error = error.error
          this.loading = false
        })
      },
      filterItems: function (items) {
        if (!items || items.length < 0) {
          console.error('Invalid items, nothing to filter...')
          return items
        }
        var specials = []
        for (var i = 0; i < items.length; i++) {
          var item = items[i]
          if (item.date_start && item.date_end) {
            var dateStart = moment(item.date_start)
            var dateEnd = moment(item.date_end)
            if (dateStart.isValid() && dateEnd.isValid()) {
              if (dateStart.isAfter(dateEnd)) {
                console.error('Invalid date for id:' + item.id + ' with dateStart:' + dateStart + ' and dateEnd:' + dateEnd)
                continue
              }
              specials.push(item)
            }
          }
        }

        var select = 0
        if (specials.length > 0) {
          console.log('Specials event:' + specials.length)

          // randomly select single special
          if (specials && specials.length > 1) {
            select = Math.floor(Math.random() * specials.length)
            return [specials[select]]
          }
          return specials
        } else {
          // randomly select single item
          if (items && items.length > 1) {
            select = Math.floor(Math.random() * items.length)
            return [items[select]]
          }
          return items
        }
      },
      refresh: function () {
        this.getItems((items) => {
          var filtered = this.filterItems(items)
          this.items = filtered
        })
      }
    }
  }
</script>

<style lang="scss">
@import "../assets/app_setting.scss";

.page-landing {
}

/* slick */

.slick-wrapper {
  padding-right: 0;

  @media screen and (min-width: $desktop) {
    padding-right: 20px;
  }
}

$slick-control-width: 60px;
$slick-control-height: 80px;
$slide-control-offset-side: 20px;

.slick-prev, .slick-next {
  z-index: 100;
  width: ($slick-control-width * 2 / 3);
  height: ($slick-control-height * 2 / 3);
  color: black;
  transition: all .2s ease-in;

  @media screen and (min-width: $tablet) {
    width: $slick-control-width;
    height: $slick-control-height;
  }

  &, &:focus {
    background: rgba(0,0,0,0.3);
  }

  &:hover {
    background: rgba(0,0,0,0.5);
  }

  &.slick-disabled {
    background: rgba(0,0,0,0.1);
  }

  &:before {
    color: rgba(255,255,255,0.5);
    // content: '\279C';
    content: '\25BA';
    font-size: 1rem;

    @media screen and (min-width: $tablet) {
      font-size: 2rem;
    }
  }
}

.slick-prev {
  left: ($slide-control-offset-side / 2) !important;
  top: calc(50% - (#{$slick-control-height} / 2.0));
  transform: rotate(180deg);

  @media screen and (min-width: $tablet) {
    left: $slide-control-offset-side !important;
  }
}

.slick-next {
  right: ($slide-control-offset-side / 2) !important;

  @media screen and (min-width: $tablet) {
    right: $slide-control-offset-side !important;
  }
}

.slick-dotted.slick-slider {
  margin-bottom: 0px;
}

.slick-dots {
  bottom: 10px;

  li {
    background-color: rgba(255,255,255,0.1);
    border-radius: 10px;

    button:before,
    &.slick-active button:before {
      color: rgba(255,255,255,0.8);
      // content: '\25FE'; // a filled square
    }

    &.slick-active button:before {
      opacity: 1.0;
      color: white;
    }

    button {
      &:before {
        opacity: .40;
      }
    }
  }
}

// arrow

.arrow-down {
  text-align: center;
  position: relative;
}

.arrow-down a {
  padding-top: 60px;
}
.arrow-down a span {
  position: absolute;
  top: 20px;
  left: 50%;
  width: 15px;
  height: 15px;
  margin-left: -8px;
  border-left: 1px solid $color-gray;
  border-bottom: 1px solid $color-gray;
  transform: rotate(-45deg);
  animation: arrow-down-animate 1.5s infinite;
  box-sizing: border-box;
}
@keyframes arrow-down-animate {
  0% {
    transform: rotate(-45deg) translate(0, 0);
  }
  30% {
    transform: rotate(-45deg) translate(-10px, 10px);
  }
  80% {
    transform: rotate(-45deg) translate(0, 0);
  }
}

// main gallery

.gallery-container {
  min-height: 800px;
  margin-top: 70px;
  padding: 15px;
  padding-top: 30px;
  padding-bottom: 80px;
  padding-right: 0px;

  @media screen and (min-width: $desktop) {
    padding: 0px;
    padding-top: 30px;
    padding-bottom: 80px;
  }

  .title {
    padding-left: 0px;

    @media screen and (min-width: $desktop) {
      padding-left: 10px;
    }
  }
}

.lb-image {
  width: auto !important
}

.top {
  padding: 10px;
  background: $color-gold;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  transition: 1s linear;
  position: relative;
  width: 35px;
  height: 35px;

  span {
    position: absolute;
    top: 18px;
    left: 50%;
    width: 15px;
    height: 15px;
    margin-left: -7px;
    border-left: 1px solid $color-white;
    border-bottom: 1px solid $color-white;
    transform: rotate(135deg);
    animation: arrow-up-animate 3s infinite;
    box-sizing: border-box;
  }
  @keyframes arrow-up-animate {
    0% {
      transform: rotate(135deg) translate(0, 0);
    }
    30% {
      transform: rotate(135deg) translate(-10px, 10px);
    }
    80% {
      transform: rotate(135deg) translate(0, 0);
    }
  }
}

</style>



// WEBPACK FOOTER //
// Landing.vue?1d5f05a3